import React, { FC, useMemo } from 'react';
import { KompisText } from '@inter-ikea-kompis/react-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { CoverItem } from 'sofa-reborn-react';
import { localeService } from '../../../services';
import {
	ArticleNoText,
	ArticleIdText,
	MaterialDescription,
	DescriptionHeadline,
	RemovableText,
	MaterialWrapper,
	MaterialText,
} from './CoverProductDescriptionContentStyle';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

const CoverProductDescriptionContent: FC = () => {
	const replaceCovers = useSelector<RootState, CoverItem[]>(
		(state) => state.cover.replaceCoverItems
	);
	const missingCover = useSelector<RootState, boolean>((state) => state.cover.missingCover);
	const selectedCoverState = useSelector<RootState, CoverItem>(
		(state) => state.cover.selectedCover as CoverItem
	);
	const languageCode = localeService.getLanguageCode();
	const selectedCover =
		missingCover && !replaceCovers.includes(selectedCoverState)
			? replaceCovers[0]
			: selectedCoverState;
	const coverItems = useSelector<RootState, CoverItem[]>((state) => state.cover.coverItems);

	const info = useMemo(() => {
		const currentCover = coverItems.find((cover) => cover.coverName === selectedCover.coverName);
		if (currentCover) {
			const productDescription = currentCover.productDescription
				? currentCover.productDescription.map((description: string) => {
						return <p key={description}>{description}</p>;
				  })
				: '';
			const careInstructions = currentCover.careInstructions
				? currentCover.careInstructions.map((careInstruction: string) => {
						return <div key={careInstruction}>{careInstruction}</div>;
				  })
				: '';

			let materialDescription;
			if (
				currentCover.isRemovable &&
				currentCover.materialDescription &&
				currentCover.materialDescription.length > 1
			) {
				materialDescription = currentCover.materialDescription.map((description) => {
					return (
						<div key={description.textPart}>
							<MaterialWrapper>
								{description.textPart}
								<MaterialText>{description.text}</MaterialText>
							</MaterialWrapper>
						</div>
					);
				});
			} else {
				materialDescription =
					selectedCover.materialDescription && selectedCover.materialDescription[0]
						? selectedCover.materialDescription[0].text
						: '';
			}
			return {
				productDescription,
				careInstructions,
				materialDescription,
			};
		} else {
			return {
				productDescription: '',
				careInstructions: '',
				materialDescription: '',
			};
		}
	}, [selectedCover, languageCode]);

	return (
		<div>
			<ArticleNoText>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
					{localeService.getTranslation('productArticleNo')}
				</KompisText>
			</ArticleNoText>
			<ArticleIdText>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium} bold={true}>
					{selectedCover.articleIdText}
				</KompisText>
			</ArticleIdText>
			<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
				{info.productDescription}
			</KompisText>
			<DescriptionHeadline hasProductDescription={selectedCover.productDescription !== null}>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium} bold={true}>
					{localeService.getTranslation('coverPickerCareInstructions')}
				</KompisText>
			</DescriptionHeadline>
			<RemovableText>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
					{selectedCover.isRemovable
						? localeService.getTranslation('coverPickerRemovableCover')
						: localeService.getTranslation('coverPickerFixedCover')}
				</KompisText>
			</RemovableText>
			<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
				{info.careInstructions}
			</KompisText>
			<MaterialDescription>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium} bold={true}>
					{localeService.getTranslation('coverPickerMaterial')}
				</KompisText>
			</MaterialDescription>
			<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
				{info.materialDescription}
			</KompisText>
		</div>
	);
};
export default CoverProductDescriptionContent;
